import {Button} from 'antd'
import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

const ButtonMap = ({url, ...props}) => {
    const map = useMapContext()

    const onClick = async () => {
        const isFm = n => 'FM' === n.data.bizNodeType

        const next = chain => {
            const [n] = chain
            const yieldChildren = [...n.children].some(isFm)
            const yieldNode = ! yieldChildren && n.data.pkid
            return {yieldChildren, yieldNode}
        }

        const {prjId, sVer} = map.data
        const pkids = []

        for (const n of map.topNodes(map.selectedNodes)) {
            for (const nn of map.dfs(n, next)) {
                pkids.push(nn.data.pkid)
            }
        }

        await runAsync(
            () => http.post(url, {pkids, prjId, sVer}),
            {action: props.children}
        )

        map.refreshMap()
    }

    return (
        <Button
            onClick={onClick}
            {...props}
        />
    )
}

export const PropertiesPaneButtonClearMap = props => {
    return (
        <ButtonMap
            url="/autoIntegrate/batchUninstallFmMap"
            {...props}
        >
            批量卸载功能地图模件
        </ButtonMap>
    )
}

export const PropertiesPaneButtonIntegrateMap = props => {
    return (
        <ButtonMap
            url="/autoIntegrate/batchIntegrateFmMap"
            {...props}
        >
            批量集成功能地图模件
        </ButtonMap>
    )
}
